module.exports = __webpack_public_path__ + "img/ring_g_o_0_0@2x.1b676bd8.png";